import FleetListView from '../../components/FleetListView';

FleetListScreen.propTypes = {};

function FleetListScreen(props) {
    // MARK: ---- PROPERTIES ----

    return (
        <div>
            <div className="container-fluid px-4 my-4">
                <FleetListView />
            </div>
        </div>
    );
}

export default FleetListScreen;
